import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 1.5rem;
  flex-direction: column;
  position: sticky;
  top: 5rem;
`;

export const Anchor = styled.a`
  font-family: ${({ theme }) => theme.fontFamilies.secondary};
  font-size: 0.875rem;
  line-height: 160%;
  text-decoration: none;
  color: ${({ theme }) => theme.colors.black};

  &:hover,
  &[aria-current="true"] {
    color: ${({ theme }) => theme.colors.red};
  }
`;
